import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Phone from "../form/Phone";
import Email from "../form/Email";
import FirstName from "../form/FirstName";
import LastName from "../form/LastName";
import { config } from '_config';

export default function MonitoringStep1({ state, onChange, validated }) {

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        {config.skin === 'v2-basic' && <h2>Mark to monitor</h2>}
        <div className="polaroid">
            <Form.Group className="mb-3" controlId="trademarkName">
              <Form.Label required>Enter the mark you are wanting to monitor</Form.Label>
              <Form.Control
                type="text"
                required
                placeholder="Enter the mark you are wanting to monitor"
                onChange={onChange}
                data-hj-allow
                value={state.trademarkName ? state.trademarkName : ""}
              />
              <Form.Control.Feedback type="invalid">Please provide a valid mark</Form.Control.Feedback>
            </Form.Group>
        </div>
      </div>
    </Form>
  );
}
